import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import UploadIcon from "../../../../../animation/Hero/Upload icon.svg";
import DownloadIcon from "../../../../../animation/Hero/download icon.svg";
import CrossIcon from "../../../../../animation/jobs/Cross icon.svg";
import { removeResume, uploadResume } from "../../../../../redux/actions/profile";
import { store } from "../../../../../redux/store";
import styles from "../../../Profile.module.css";

export default function ResumeUpload() {
  const dispatch = useDispatch();
  const resume = useSelector((state) => state.profile.resumefile); 
  const [fileName, setFileName] = useState('');
  
  const handleFileChange = (e) => {
    if (e.target.files.length > 0) {
      const file = e.target.files[0];
      setFileName(file.name);
      dispatch(uploadResume(file));
    }
  };

useEffect(() => {
  if (resume && resume.name) {
    setFileName(resume.name);
  }
}, [resume]);

  const handleRemoveFile = () => {
    setFileName("");
    dispatch(removeResume())
  };

  console.log('store',store.getState().profile)

const handleDownload = () => {
  if (!resume) return;
  const url = URL.createObjectURL(resume);
  const link = document.createElement("a");
  link.href = url;
  link.download = resume.name || "resume.pdf";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};


  return (
    <div className={styles.resumeUpload}>
      
      {fileName ? (
        <>
          <div className={styles.uploadBox}>
          <div className={styles.filePreview}>
            <span className={styles.fileName}> {fileName}</span>
            <button
              type="button"
              className={styles.removeBtn}
              onClick={handleRemoveFile}
            >
              <img src={CrossIcon} className={styles.close_icon} alt="Remove" />
            </button>
            
          </div>
          <button  onClick={handleDownload} className={styles.download_button}>
              <img
                src={DownloadIcon}
                alt="Download"
                className={styles.uploadIcon}
                style={{ cursor: "pointer" }}
              />
            </button>
        </div>
        </>
      ) : (
        <>
          <label className={styles.uploadBox}>
            <span className={styles.upload_text}>Upload resume here</span>
            <img src={UploadIcon} alt="Upload" className={styles.uploadIcon} />
            <input
              type="file"
              accept=".pdf,.doc,.docx"
              className={styles.hiddenInput}
              onChange={handleFileChange}
            />
          </label>
        </>
      )}
      <p className={styles.supportedText}>Supported format - PDF, DOC</p>
    </div>
  );
}